// Default GTM loader; set GATSBY_DEFER_GTM=false to use the immediate plugin.
exports.onInitialClientRender = (_, { id }) => {
  if (process.env.NODE_ENV !== 'production' || window.__deferredGtmScheduled) return;
  window.__deferredGtmScheduled = true;

  const load = () => {
    const existing = Array.from(document.scripts).some(script => {
      try {
        const url = new URL(script.src);
        return url.origin === 'https://www.googletagmanager.com' &&
          url.pathname === '/gtm.js' && url.searchParams.get('id') === id;
      } catch (_) { return false; }
    });
    if (existing) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(script);
  };

  const afterLoad = () => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(load, { timeout: 1000 });
    } else {
      window.setTimeout(load, 0);
    }
  };
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
};

exports.onRouteUpdate = ({ location, prevLocation }, { routeChangeEventName }) => {
  if (process.env.NODE_ENV !== 'production') return;
  // Capture now: the queue can be consumed after another SPA navigation.
  const page = {
    event: routeChangeEventName,
    page_location: location.href || window.location.href,
    page_path: location.pathname + (location.search || '') + (location.hash || ''),
    page_referrer: prevLocation?.href || document.referrer,
  };
  window.setTimeout(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(page);
  }, 50);
};
